<template>
  <div>
    <div class="d-flex justify-content-center">
      <b-spinner large v-if="loading" class="mx-2" />
      <span v-if="loading">Loading...</span>
    </div>.
    <b-card v-if="!loading">
      <validation-observer v-slot="{ invalid }" ref="editRawMaterialValidation">
        <b-form @submit.prevent="editRawMaterial" v-if="!loading">
          <b-row>
            <!-- Equipment Document -->
          <b-col md="12" class="d-flex justify-content-end">
            <b-form-group style="margin-top: 20px">
              <b-button
                variant="primary"
                @click="handleDocumentBtn(rawmaterialsID.id)"
                >Documents</b-button
              >
              <b-spinner
                class="mt-1"
                variant="success"
                label="Spinning"
                block
                v-if="loading"
                style="width: 3rem; height: 3rem; margin-left: 32px"
              ></b-spinner>
            </b-form-group>
            <b-modal
              ref="modal-view-raw-material-document"
              id="modal-view-raw-material-document"
              ok-only
              ok-title="View"
              centered
              size="lg"
              title="View Raw Material Documents"
              :hide-footer="true"
            >
              <DocumentUpload
                @deleteFile="deleteFile"
                @downloadFile="downloadFile"
                @uploadFiles="uploadFiles"
                :documentDetails="documentDetails"
              />
            </b-modal>
          </b-col>
          <!-- Equipment Document -->
            <b-col md="6">
              <b-form-group
                label="Raw Material Name"
                label-for="mc-Raw Material-Supplier"
              >
                <b-form-input
                  id="mc-Raw Material-Supplier"
                  placeholder="Raw Material"
                  v-model="rawmaterialsID.name"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="Raw Material Code"
                label-for="mc-Raw Material-Code"
              >
                <b-form-input
                  id="mc-Raw Material-Code"
                  v-model="rawmaterialsID.code"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label-for="mc-stock-threshold"
                label="Low Stock Threshold"
              >
                <div class="form-label-group">
                  <b-form-input
                    id="mc-stock"
                    type="text"
                    @keypress="allowOnlyNumbers($event)"
                    @wheel="allowOnlyNumbers($event)"
                    placeholder="Low Stock Threshold"
                    v-model="rawmaterialsID.lowStock"
                  />
                </div>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group
                label="Category"
                label-for="mc-Category"
              >
                <!-- <b-form-input
                  v-model="rawmaterialsID.category.name"
                  placeholder="RMTest1"
                /> -->
                <b-form-select
              v-model="rawmaterialsID.categoryID"
              :options="parentCategoryList"
              value-field="id"
              text-field="name"
              @change="setSubCategory" 
            />
              </b-form-group>
            </b-col>
            <b-col cols="6">
          <b-form-group :disabled="rawmaterialsID.categoryID != null" label="Sub Category" label-for="mc-subCategory">
            <b-form-select
              v-model="rawmaterialsID.productCategorySubId"
              :options="subCategoryList"
              value-field="id"
              text-field="name"
            />
          </b-form-group>
        </b-col>
            <b-col cols="6">
              <b-form-group label="UOM" label-for="mc-Uom">
                <b-form-select
                v-model="uomName"
                :options="itemUomList"
                value-field="id"
                text-field="name"
                @change="newuom(uomName)"
              />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Price (Rs)" label-for="Price (Rs)">
                <b-form-input
                  type="number"
                  id="mc-Raw Material-Price"
                  placeholder="Raw Material Price"
                  v-model="rawmaterialsID.purchasePrice"
                    @keypress="allowOnlyNumbers($event)"
                    @wheel="allowOnlyNumbers($event)"
                />
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group label="Preferred Supplier" label-for="mc-Supplier">
                <b-form-select
                  v-model="rawmaterialsID.supplierId"
                  :options="supplierOptions"
                  value-field="id"
                  text-field="name"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" class="mb-2">
              <label for="textarea-default">Raw Material Description</label>
              <b-form-textarea
                id="textarea-default"
                rows="5"
                required
                placeholder="Description"
                v-model="rawmaterialsID.description"
              />
            </b-col>

              <b-col cols="12">
                <CustomFieldsDetails
                  :AdditionalFields="rawmaterialsID.additionalFields"
                  :ModuleReference="'RawMaterial'"
                  @onchange="additionalFieldChanges"
                ></CustomFieldsDetails>
              </b-col>
        

            <!-- <b-row class="p-1">
              <b-col cols="12">
                <h4 class="mb-3">Reordering Information</h4>
              </b-col>
              <b-col md="6">
                <b-form-group label="Order Quantity" label-for="order-qty">
                  <validation-provider
                    rules="required"
                    #default="{ errors }"
                    name="order quantity"
                  >
                    <b-form-input
                      id="order-qty"
                      v-model="orderingInfo.orderQty"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small v-if="errors.length" class="text-danger text-end">{{
                      errors[0]
                    }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Due Days" label-for="due-days">
                  <validation-provider
                    rules="required"
                    #default="{ errors }"
                    name="due days"
                  >
                    <b-form-input
                      id="due-days"
                      v-model="orderingInfo.dueDays"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small v-if="errors.length" class="text-danger text-end">{{
                      errors[0]
                    }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  label="Supplier Preference"
                  label-for="supplier-preference"
                >
                  <validation-provider
                    rules="required"
                    #default="{ errors }"
                    name="supplier preference"
                  >
                    <b-form-select
                      v-model="orderingInfo.supplierPreference"
                      :options="supplierOptions"
                      value-field="id"
                      text-field="name"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small v-if="errors.length" class="text-danger text-end">{{
                      errors[0]
                    }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Issuer" label-for="issuer">
                  <validation-provider
                    rules="required"
                    #default="{ errors }"
                    name="issuer"
                  >
                    <b-form-select
                      v-model="orderingInfo.issuer"
                      :options="optionsSalesPerson"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small v-if="errors.length" class="text-danger text-end">{{
                      errors[0]
                    }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Warehouse ID" label-for="warehouse-id">
                  <validation-provider
                    rules="required"
                    #default="{ errors }"
                    name="warehouse"
                  >
                    <b-form-select
                      v-model="orderingInfo.warehouseId"
                      :options="optionsWarehouse"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small v-if="errors.length" class="text-danger text-end">{{
                      errors[0]
                    }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Order Type" label-for="order-type">
                  <validation-provider
                    rules="required"
                    #default="{ errors }"
                    name="order type"
                  >
                    <b-form-input
                      id="order-type"
                      v-model="orderingInfo.type"
                      :state="errors.length > 0 ? false : null"
                      disabled
                    />
                    <small v-if="errors.length" class="text-danger text-end">{{
                      errors[0]
                    }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row> -->

            <b-row class="p-1">
              <b-col md="12" class="d-flex justify-content-end">
                <b-button type="submit" variant="primary" @click="editRawMaterial"
                  >Submit</b-button
                >
              </b-col>
            </b-row>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BForm,
  BFormInput,
  BFormTextarea,
  BFormSelect,
  BFormDatepicker,
  BFormGroup,
  BButton,
  BSpinner,
  BCard
} from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import {  } from "@/libs/customFn";
import DocumentUpload from "@/views/component/DocumentUpload.vue";
import { deleteRawMaterialDocument, uploadRawMaterialMultipleDocuments, uploadRawMaterialDocument, downloadRawMaterialDocument } from '@/store/RawMaterial/services';
import { customSwal, customError, fnSortingDropdown, allowOnlyNumbers } from "@/libs/customFn";
import CustomFieldsDetails from "@/views/component/CustomFieldsDetails.vue";
export default {
  name: "EditRawMaterial",
  components: {
    BRow,
    BCol,
    BForm,
    BFormInput,
    BFormTextarea,
    BFormSelect,
    BFormDatepicker,
    BFormGroup,
    BButton,
    ValidationProvider,
    ValidationObserver,
    BSpinner,
    BCard,
    required,
    fnSortingDropdown,
    DocumentUpload,
    CustomFieldsDetails
  },
  
  data() {
    return {
      id: this.$route.params.id,
      uomName: "",
      uomid: "",
      optionsSalesPerson: [],
      optionsWarehouse: [],
      orderingInfo: {
        orderQty: null,
        dueDays: null,
        supplierPreference: null,
        issuer: null,
        warehouseId: null,
        type: "PurchaseOrder",
      },
      required,
      itemUomList: [],
      documentDetails: {
        isDelete: false,
        documentList: [],
      },
      parentCategoryList: [],
       subCategoryList:[],
    };
  },
  computed: {
    ...mapGetters("rawmaterialModule", {
      rawmaterialsID: "rawmaterialsID",
      loading: "loading",
      documents: "documents",
      file: "file",
    }),
    ...mapGetters("itemUomModule", {
      itemUoms: "itemuom",
      loading: "loading",
    }),
    ...mapGetters("itemcategoryModule", {
      itemCategories: "itemcategories",
      loading: "loading",
    }),
    ...mapGetters("rawmaterialModule", {
      loading: "loading",
    }),
    ...mapGetters("supplierModule", {
      suppliers: "suppliers",
      loading: "loading",
    }),
    ...mapGetters("salesPersonModule", {
      SalesPersonList: "salesperson",
      loading: "loading",
    }),
    ...mapGetters("warehouseModule", {
      warehouses: "warehouse",
      warehouseLoading: "loading",
    }),
    supplierOptions() {
      return fnSortingDropdown(this.suppliers, "asc", "name");
    },
  },
  methods: {
    ...mapActions("rawmaterialModule", ["updateRawMaterialAction"]),
    ...mapActions("itemUomModule", ["getItemUOMListAction"]),
    ...mapActions("itemcategoryModule", ["getItemCategoryListAction", "getItemCategoryAction", "getItemSubCategoryListAction"]),
    ...mapActions("supplierModule", ["getSupplierListAction"]),
    ...mapActions("salesPersonModule", ["getSalesPersonListAction"]),
    ...mapActions("warehouseModule", ["getWarehouseListAction"]),
    ...mapActions("rawmaterialModule", ["getRawMaterialListByIdAction", "getRawMaterialDocumentListAction"]),
    success() {
      this.$swal({
        title: "Raw Materials updated!",
        text: "You have successfully updated the Raw materials!",
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$router.push({ name: "rawmaterials-list" });
        }
      });
    },
    async setSubCategory(){
      this.subCategoryList = await this.getItemSubCategoryListAction(this.rawmaterialsID.categoryID);
      this.subCategoryList = fnSortingDropdown(
        this.subCategoryList,
        "asc",
        "name"
      );
    },

    async newuom(id)
    {
      this.rawmaterialsID.defaultUomID = id
      
    },
    async editRawMaterial() {
      const isValid = await this.$refs.editRawMaterialValidation.validate();
      if (isValid) {
        this.$swal({
          title: "Updating...",
          text: "Please wait while the raw material is being updated...",
          allowEscapeKey: false,
          allowOutsideClick: false,
          didOpen: () => {
            this.$swal.showLoading();
          },
        });

        let payload = {
          ...this.rawmaterialsID,
          reordering: this.rawmaterialsID.reordering || {},
          additionalFields: this.rawmaterialsID.additionalFields,
        };

        payload.lowStock = payload.lowStock == '' ? 0 : payload.lowStock;
        
        // Include orderingInfo only if there are changes
        if (this.orderingInfo.orderQty !== null)
          payload.reordering.orderQty = this.orderingInfo.orderQty;
        if (this.orderingInfo.dueDays !== null)
          payload.reordering.dueDays = this.orderingInfo.dueDays;
        if (this.orderingInfo.supplierPreference !== null)
          payload.reordering.supplierPreference =
            this.orderingInfo.supplierPreference;
        if (this.orderingInfo.issuer !== null)
          payload.reordering.issuer = this.orderingInfo.issuer;
        if (this.orderingInfo.warehouseId !== null)
          payload.reordering.warehouseId = this.orderingInfo.warehouseId;
        if (this.orderingInfo.type !== null)
          payload.reordering.type = this.orderingInfo.type;

        this.updateRawMaterialAction(payload)
          .then(() => {
            this.$swal.close(); // Close swal after successful update
            this.success();
            this.getRawMaterialListByIdAction(this.id);
          })
          .catch((err) => {
            this.$swal.close(); // Close swal if there is an error
            customError(err);
          });
      }
    },
    async handleDocumentBtn(referenceId) {
      try {
        console.log('referenceIdForThis', referenceId);
        await this.getRawMaterialDocumentListAction(referenceId);
        if (this.documents.length > 0) {
          this.documentDetails.documentList = this.documents;
          this.documentDetails.isDelete = true;
        }
        this.$refs["modal-view-raw-material-document"].show();
      } catch (error) {
        console.error("Error fetching documents:", error);
      }
    },

    async uploadFiles(selectedFiles) {
      let loader = this.$swal({
        title: 'Processing...',
        text: 'Please wait while the document(s) is being added',
        onOpen: () => {
          this.$swal.showLoading();
        },
        allowOutsideClick: () => !this.$swal.isLoading(),
        buttonsStyling: false,
        showConfirmButton: false,
      });
      const referenceId = this.rawmaterialsID.id;

      const maxSize = 20 * 1024 * 1024;
        if (this.selectedFiles && this.selectedFiles.size > maxSize) {
          alert('File size exceeds 20 MB limit. Please choose a smaller file.');
          this.submitting = false;
          return;
        }

      if (selectedFiles.length > 1) {

        await uploadRawMaterialMultipleDocuments(selectedFiles, referenceId)
          .then((response) => {
            setTimeout(() => {
              this.$swal.close();
            }, 3000);
            customSwal('Your file(s) have been successfully uploaded.');
            loader.close();
          })
          .catch((error) => {
            customError(error);
            loader.close();
          });
      } else if (selectedFiles.length < 2) {
        await uploadRawMaterialDocument(selectedFiles, referenceId)
          .then((response) => {
            setTimeout(() => {
              this.$swal.close();
            }, 3000);
            customSwal('Your file(s) have been successfully uploaded.');
            loader.close();
          })
          .catch((error) => {
            customError(error);
            loader.close();
          });
      }
      
      await this.getRawMaterialDocumentListAction(referenceId);
      this.documentDetails.documentList = this.documents;
      this.documentDetails.isDelete = true;
      
      this.$nextTick(() => {
        this.$bvModal.show('modal-view-raw-material-document');
      });
    },

    async deleteFile(id) {
      let loader = this.$swal({
        title: 'Processing...',
        text: 'Please wait while the document is being deleted',
        allowEscapeKey: false,
        allowOutsideClick: false,
        buttonsStyling: false,
        showConfirmButton: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      await deleteRawMaterialDocument(id)
        .then((response) => {
          loader.close();
          customSwal();
        })
        .catch((error) => {
          loader.close();
          customError(error);
        });

      await this.getRawMaterialDocumentListAction(this.rawmaterialsID.id);
      this.documentDetails.documentList = this.documents;
      
      this.$nextTick(() => {
        this.$bvModal.show('modal-view-raw-material-document');
      });
    },

    async downloadFile(id, fileName) {
      let loader = this.$swal({
        title: 'Processing...',
        text: 'Please wait while the document is being prepared for download',
        onOpen: () => {
          loader.showLoading();
        },
        allowOutsideClick: () => !loader.isLoading(),
        buttonsStyling: false,
        showConfirmButton: false,
      });

      try {
        const response = await downloadRawMaterialDocument(id);
        const url = window.URL.createObjectURL(
          new Blob([response.data], {
            type: response.headers['content-type'] || 'application/octet-stream',
          })
        );
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName); // Use the provided fileName parameter directly
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); // Clean up DOM by removing the link element after clicking
        window.URL.revokeObjectURL(url); // Free up memory by releasing object URL

        loader.close();
      } catch (error) {
        console.error('Download failed:', error);
        loader.close();
        this.error('Failed to download the file. Please try again.'); // Updated error message for better clarity
      }
    },
    additionalFieldChanges(customFields) {
      this.rawmaterialsID.additionalFields = customFields;
    },
  },
  async mounted() {
    await this.getItemUOMListAction();
    await this.getRawMaterialListByIdAction(this.id);
    await this.getSupplierListAction();

    this.itemUomList = fnSortingDropdown(this.itemUoms, "asc", "name");

    let uom = this.itemUoms.filter((obj) => {
      return obj.id === this.rawmaterialsID.defaultUomID;
    });

    if (uom.length > 0) {
      this.uomName = uom[0].id;
    }

    await this.getSalesPersonListAction().then(() => {
      this.SalesPersonList.map((v, i) =>
        this.optionsSalesPerson.push({
          value: v.id,
          text: `${v.firstName}` + " " + `${v.lastName}`,
        })
      );
      this.optionsSalesPerson = fnSortingDropdown(
        this.optionsSalesPerson,
        "asc",
        "text"
      );
    });
    await this.getWarehouseListAction().then(() => {
      this.warehouses.map((v, i) =>
        this.optionsWarehouse.push({
          value: v.id,
          text: `${v.name}`,
        })
      );
      this.optionsWarehouse = fnSortingDropdown(
        this.optionsWarehouse,
        "asc",
        "text"
      );
    });

    await this.getItemCategoryListAction().then(() => {
      console.log("itemCategories", this.itemCategories);
      this.parentCategoryList = fnSortingDropdown(
        this.itemCategories.filter((x) => !x.isSub),
        "asc",
        "name"
      );
    });

    this.setSubCategory();

    // Initialize orderingInfo if it's null or undefined
    if (!this.rawmaterialsID.reordering) {
      this.rawmaterialsID.reordering = {};
    } else {
      this.orderingInfo = { ...this.rawmaterialsID.reordering };
    }
  },
  setup(){
    return {
      allowOnlyNumbers
    }
  }
};
</script>
